__turbopack_context__.v({
  "textArea": "TextArea-module-scss-module__yBBJJW__textArea",
});
